import { createContext } from "react";
import { GLOBAL_CONTEXT } from "../types/store";

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const Context: GLOBAL_CONTEXT | any = createContext({});

export default Context;
